import { render } from "./SplitByIdResults.vue?vue&type=template&id=0053ab31&scoped=true&lang=pug"
import script from "./SplitByIdResults.vue?vue&type=script&lang=js"
export * from "./SplitByIdResults.vue?vue&type=script&lang=js"

import "./SplitByIdResults.vue?vue&type=style&index=0&id=0053ab31&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0053ab31"]])

export default __exports__